module.exports = require('./lib/jspath');